// extracted by mini-css-extract-plugin
export var active = "_lt-e";
export var blink = "_lt-f";
export var dropDownSelector = "_lt-5";
export var dropDownWrapper = "_lt-4";
export var fakeCursor = "_lt-d";
export var fontSizeButton = "_lt-7";
export var formQuillEditor = "_lt-0";
export var pressed = "_lt-g";
export var qlBlank = "_lt-1";
export var textFormattingToolbar = "_lt-2";
export var textFormattingToolbarClosed = "_lt-3";
export var textFormattingToolbarInline = "_lt-6";
export var textToolbarOption = "_lt-8";
export var toolbarCell = "_lt-a";
export var toolbarCellCollapsed = "_lt-b";
export var toolbarOptionHitArea = "_lt-c";
export var toolbarOverflow = "_lt-9";